import { ParallaxProvider } from 'react-scroll-parallax';
import ParticlesBackground from './componentes/ParticlesBackground';
import Header from './componentes/Header';
import Inicio from './componentes/Inicio';
import Servicios from './componentes/Servicios';
import Portafolio from './componentes/Portafolio';
import Contacto from './componentes/Contacto';
import Footer from './componentes/Footer';
import PorqueSitioWeb from './componentes/PorqueSitioWeb';
import SolucionesParaTodos from './componentes/SolucionesParaTodos';
export default function App() {
  return (
    <>
      <ParallaxProvider>
        <ParticlesBackground />
        <Header />
        <main>
          <Inicio />
          <PorqueSitioWeb />
          <SolucionesParaTodos />
          <Servicios />
          <Portafolio />
          <Contacto />
          <Footer />
        </main>
      </ParallaxProvider>
    </>
  );
}
